module.exports = __webpack_public_path__ + "candidatepresentation.png?daae6233a821ec35b61c2577d003871d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aupair/candidatepresentation.png
// module id = 295
// module chunks = 0